import { useState } from 'react';
import { css, jsx } from '@emotion/react';
import { Badge } from '../../display/Badge/Badge.es.js';
import { FloatingBox } from '../../display/FloatingBox/FloatingBox.es.js';
import { TagLabel } from '../../display/TagLabel/TagLabel.es.js';
import { IconButton } from '../IconButton/IconButton.es.js';
import { Menu } from '../../forms/Menu/Menu.es.js';
import { MenuItem } from '../../forms/Menu/MenuItem.es.js';
import { useClickOutside } from '../../../hooks/useClickOutside.es.js';
import { labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles("TabsDropdown", {
  root: css`
    position: relative;
  `,
  summary: css`
    // Hides default icon on details element
    &::-webkit-details-marker {
      display: none;
    }

    &::before {
      display: none;
    }
  `,
  menu: css`
    padding: 10px;
    min-width: 250px;
  `,
  badgeAndTagLabel: css`
    margin-left: var(--zds-space-8, 8px);
  `
});
const TabsDropdown = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuItems = props.items.map((item) => jsx(
    MenuItem,
    { disabled: item.disabled, href: item.href, isSelected: item.href === props.selectedItemHref, key: item.href, onClick: (event) => {
      setIsOpen(false);
      props.onChooseItem(item, event);
    } },
    item.text,
    item.badgeText && jsx(Badge, { color: item.badgeColor, css: Styles.badgeAndTagLabel }, item.badgeText),
    item.tagLabelText && jsx(TagLabel, { color: item.tagLabelColor, css: Styles.badgeAndTagLabel }, item.tagLabelText)
  ));
  const [setClickOutsideNode] = useClickOutside({
    onClickOutside: () => {
      setIsOpen(false);
    }
  });
  const containerHandlers = {
    onKeyUp: (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    }
  };
  return jsx(
    "div",
    Object.assign({ ref: setClickOutsideNode }, containerHandlers, { "data-zds": true }),
    jsx(IconButton, { color: "icon-tertiary", icon: "navMoreHoriz", label: "More items…", ariaExpanded: isOpen, onClick: () => setIsOpen(!isOpen), size: {
      medium: "xsmall",
      large: "small"
    }[props.size], tooltipPosition: "west" }),
    isOpen && jsx(
      FloatingBox,
      { align: "right" },
      jsx(
        "div",
        { css: Styles.menu, "data-zds": true },
        jsx(Menu, { ariaLabel: "" }, menuItems)
      )
    )
  );
};

export { TabsDropdown };
//# sourceMappingURL=TabsDropdown.es.js.map
